import { render } from "./SearchResultsApp.vue?vue&type=template&id=191828fa"
import script from "./SearchResultsApp.vue?vue&type=script&lang=js"
export * from "./SearchResultsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/SearchResultsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "191828fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('191828fa', __exports__)) {
    api.reload('191828fa', __exports__)
  }
  
  module.hot.accept("./SearchResultsApp.vue?vue&type=template&id=191828fa", () => {
    api.rerender('191828fa', render)
  })

}


export default __exports__